<search-input
  [placeholder]="placeholder | translate"
  [debounceTime]="1000"
  [searchTerm]="searchTerm"
  (searchInput)="onSearch($event)"
  (keyboardEnterInput)="onSearch($event)"
  (clearInput)="clearInput()"
  role="search"
  [attr.aria-label]="placeholder | translate"
></search-input>
